export var reduxKey = 'flags';
export var actionKey = '@@flags';
//# sourceMappingURL=constants.js.map